/** de — German stub. See pt-BR for rationale on partial coverage. */
import type enUS from "./en-US";
type EnResources = typeof enUS;
type DeepPartial<T> = { [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K] };

const de: DeepPartial<EnResources> = {
  nav: {
    dashboard: "Dashboard",
    people: "Personen",
    timeOff: "Abwesenheit",
    timeTracking: "Zeiterfassung",
    invoices: "Rechnungen",
    approvals: "Freigaben",
    recruiting: "Recruiting",
    performance: "Leistung",
    assets: "Ausstattung",
    complaints: "Beschwerden",
    documents: "Dokumente",
    reports: "Berichte",
    aiAssistant: "KI-Assistent",
    settings: "Einstellungen",
    primary: "Hauptmenü",
    expandSidebar: "Menü erweitern",
    collapseSidebar: "Menü einklappen",
    securityMfa: "Sicherheit & MFA",
    logout: "Abmelden",
  },
  common: {
    loading: "Lädt…",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    close: "Schließen",
    search: "Suchen",
    language: "Sprache",
    timezone: "Zeitzone",
    currency: "Währung",
    accessDenied: "Zugriff verweigert",
    accessDeniedBody: "Sie haben keine Berechtigung, diese Seite zu sehen.",
    retry: "Erneut versuchen",
    noResults: "Keine Ergebnisse",
  },
  auth: {
    welcomeBack: "Willkommen zurück",
    signInSubtitle: "Melden Sie sich in Ihrem Konto an",
    tagline:
      "Die intelligente HR-Plattform, die Ihr Team wirklich nutzen möchte. Verwalten Sie Menschen, Zeit und Kultur — alles an einem Ort.",
    demoHint: "Demo: admin@acme.com / demo1234",
    signIn: "Anmelden",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    rememberMe: "Angemeldet bleiben",
  },
  notifications: {
    title: "Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    empty: "Noch keine Benachrichtigungen.",
    justNow: "gerade eben",
    minutesAgo: "vor {{count}} Min.",
    hoursAgo: "vor {{count}} Std.",
    daysAgo: "vor {{count}} T.",
    unreadCountLabel: "Benachrichtigungen, {{count}} ungelesen",
    unreadPrefix: "Ungelesen: {{title}}",
  },
  search: {
    placeholder: "Personen, Dokumente, Aufgaben suchen…",
    groups: {
      pages: "Seiten",
      people: "Personen",
      documents: "Dokumente",
      tasks: "Aufgaben",
    },
  },
  settings: {
    preferences: "Einstellungen",
    preferencesHint:
      "Sprache, Zeitzone und Währung für die gesamte Anwendung.",
    languageLabel: "Sprache",
    timezoneLabel: "Zeitzone",
    currencyLabel: "Anzeigewährung",
  },
};

export default de;
